/// <amd-module name="Wit/Common/Controls/Boards/AgileBacklogPermissionContext" />

import * as React from "react";

interface IAgileBacklogPermissionContext {
    hasBacklogManagementPermission: boolean;
}

export const AgileBacklogPermissionContext = React.createContext<IAgileBacklogPermissionContext>({
    hasBacklogManagementPermission: false
});

interface IAgileBacklogPermissionProps {
    hasBacklogManagementPermission: boolean;
}

export const AgileBacklogPermissionProvider: React.FunctionComponent<IAgileBacklogPermissionProps> = ({
    children,
    hasBacklogManagementPermission
}) => {
    return <AgileBacklogPermissionContext.Provider value={{ hasBacklogManagementPermission }}>{children}</AgileBacklogPermissionContext.Provider>;
};

export function useBacklogManagementPermission(): boolean {
    return React.useContext(AgileBacklogPermissionContext).hasBacklogManagementPermission;
}
